export const contributionsData = [
  {
    id: 1,
    org: "Apple",
    repo: "coremltools",
    title: "Preserve integer dtype for torch.floor_divide",
    link: "https://github.com/apple/coremltools/pull/2738",
  },
  {
    id: 2,
    org: "Meta",
    repo: "lexical",
    title: "Defer onUpdate callbacks during nested commits",
    link: "https://github.com/facebook/lexical/pull/8672",
  },
  {
    id: 3,
    org: "NVIDIA",
    repo: "cosmos-framework",
    title: "Prefer NVML v2 memory info for inference setup",
    link: "https://github.com/NVIDIA/cosmos-framework/pull/41",
  },
  {
    id: 4,
    org: "AMD",
    repo: "gaia",
    title: "Refresh backends before multi-mailbox scans",
    link: "https://github.com/amd/gaia/pull/1808",
  },
  {
    id: 5,
    org: "The AI Alliance",
    repo: "tapestry",
    title: "Preserve contrib target failures",
    link: "https://github.com/The-AI-Alliance/tapestry/pull/133",
  },
  {
    id: 6,
    org: "Heym",
    repo: "heym",
    title: "Require credential access when cloning vector stores",
    link: "https://github.com/heymrun/heym/pull/187",
  },
];
